module.exports = __webpack_public_path__ + "static/media/servicios_blanco_2.d6cb6040.png";